<router-outlet></router-outlet>
<div *ngIf="showUIView">
  <div ui-view="layout"></div>
  <main>
    <div ui-view></div>
  </main>
</div>
